import { get } from "../../service/api";

const GetElectricTransaction = async (merchantId) => {
  try {
    const response = await get(
      `/dashboard/electricTransaction?merchantId=${merchantId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error GetElectricTransaction:", error);
    throw error;
  }
};

export default GetElectricTransaction;
